const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const TRACE_ID_PATTERN = /^[0-9a-f]{32}$/i;
const NUMERIC_VERSION = '[vV]?[0-9]{1,6}(?:\\.[0-9]{1,6}){0,5}(?:-(?:alpha|beta|rc)(?:\\.[0-9]{1,6})?)?(?:\\+(?:[0-9]{1,12}|[A-Fa-f0-9]{7,40}))?';
const APP_VERSION_PATTERN = new RegExp(
  `^(?:${NUMERIC_VERSION}|auth-ui@(?:${NUMERIC_VERSION}|[A-Fa-f0-9]{7,40}(?:\\+(?:[0-9]{1,12}|[A-Fa-f0-9]{7,40}))?)|git:[A-Fa-f0-9]{7,40}|dev|local|test|staging|production|unknown)$`,
);

export function canonicalUuid(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const normalized = value.trim();
  return UUID_PATTERN.test(normalized) ? normalized.toLowerCase() : null;
}

export function canonicalTraceId(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const normalized = value.trim();
  return TRACE_ID_PATTERN.test(normalized) && !/^0+$/.test(normalized)
    ? normalized.toLowerCase()
    : null;
}

export function canonicalRequestId(value: unknown): string | null {
  return canonicalUuid(value) ?? canonicalTraceId(value);
}

export function canonicalAppVersion(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const normalized = value.trim();
  return normalized.length <= 64 && APP_VERSION_PATTERN.test(normalized) ? normalized : null;
}
